import { useState } from 'react';
import type { MeResponse } from '@kassa/shared';
import { api, ApiError } from '../api';

interface Props {
  me: MeResponse;
  onSelected: (me: MeResponse) => void;
}

// Bir hesab bir neçə şirkətdə işləyəndə burada seçilir.
export function SelectCompany({ me, onSelected }: Props) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  async function choose(membershipId: string) {
    setBusy(membershipId);
    setError(null);
    try {
      onSelected(await api.selectTenant({ membershipId }));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Şəbəkə xətası. Yenidən cəhd edin.');
      setBusy(null);
    }
  }

  return (
    <div className="page-center">
      <div className="card card-wide">
        <h2>Şirkət seçin</h2>
        <p className="muted">{me.accountName}, hansı şirkətdə işləyəcəksiniz?</p>
        <ul className="choice-list">
          {me.memberships.map((m) => (
            <li key={m.membershipId}>
              <button
                type="button"
                className="choice"
                onClick={() => choose(m.membershipId)}
                disabled={busy !== null}
              >
                <span className="choice-title">{m.tenantName}</span>
                <span className="muted">{m.membershipName}</span>
              </button>
            </li>
          ))}
        </ul>
        {error && (
          <p className="bad" role="alert">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
